import { node as anthropometrics } from "src/modules/basic-health/forms/anthropometrics";
import { node as bloodGroup } from "src/modules/basic-health/forms/bloodGroup";
import { node as currentCardiologicalState } from "src/modules/basic-health/forms/current-cardiological-state";
import { node as labProcedures } from "src/modules/basic-health/forms/lab-procedures";
import { node as patientCondition } from "src/modules/basic-health/forms/patientCondition";
import { node as patientConditionReport } from "src/modules/basic-health/forms/patientConditionReport";
import { node as patientStatementOfConsent } from "src/modules/basic-health/forms/patientStatementOfConsent";
import { node as risks } from "src/modules/basic-health/forms/risks";
import { LeafNode, ParentNode } from "src/modules/shared/form-explorer";

export const forms: (ParentNode | LeafNode)[] = [
	anthropometrics,
	bloodGroup,
	currentCardiologicalState,
	labProcedures,
	risks,
	patientCondition,
	patientConditionReport,
	patientStatementOfConsent
];
